export default {
  title: 'Inkomstenrapporten',
  sections: {
    new_report: 'Nieuw rapport',
  },
  form: {
    period: {
      label: 'Periode',
    },
  },
  buttons: {
    export: 'Exporteren',
  },
  toasts: {
    failed_to_create_report: 'Rapport aanmaken mislukt',
  },
};
